import { createZodDto } from 'nestjs-zod/dto';
import z from 'zod';
import { enumValidator, WorkspaceStatus } from '#validation';
import { createListQuery } from '#web-service-api/common';
import { PartnerOrganizationWorkspaceListItemSchema } from '../response';
export const PartnerOrganizationWorkspacesListQuery = createListQuery({
    schema: PartnerOrganizationWorkspaceListItemSchema,
    filters: z.object({
        status: enumValidator({
            values: WorkspaceStatus,
            invalidValueError: 'partnerOrganization.workspaces.status.invalid',
        }).exactOptional(),
    }),
    sortable: {
        by: ['name', 'createdAt'],
        default: 'name',
    },
    pageSize: {
        default: 10,
        max: 100,
    },
});
export class PartnerOrganizationWorkspacesListQueryDto extends createZodDto(PartnerOrganizationWorkspacesListQuery.codec) {
}
